<template>
  <div
    class="join-us-wrapper bg-light-green py-xl"
    data-test-id="component-about-join-us"
  >
    <div class="container">
      <div class="flex flex-wrap  -mx-tiny">
        <div class="flex w-full px-standart">
          <p class="uppercase text-smallest opacity-muted">
            {{ $messages('about.join_us.title') }}
          </p>
        </div>
      </div>
      <div class="flex flex-wrap  -mx-tiny">
        <div class="flex w-full lg:w-1/2 px-standart">
          <p class="h4 mb-large lg:mb-0">
            {{ $messages('about.join_us.we_are_description') }}
          </p>
        </div>
        <div class="flex w-full lg:w-1/2 flex-col px-standart justify-center">
          <div class="flex justify-around items-center text-center">
            <div>
              <p class="h1">
                23
              </p>
              <p class="h2 mb-0">
                {{ $messages('about.join_us.languages') }}
              </p>
            </div>
            <div>
              <p class="h1">
                41
              </p>
              <p class="h2 mb-0">
                {{ $messages('about.join_us.nacionalities') }}
              </p>
            </div>
            <div>
              <p class="h1">
                97
              </p>
              <p class="h2 mb-0">
                {{ $messages('about.join_us.individuals') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex flex-wrap  -mx-tiny mt-large"
      >
        <div class="flex w-full px-standart">
          <AboutJoinUsTeam :show-jobs="showJobs" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showJobs: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>
